import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [faculty, setFaculty] = useState(() => {
    try { return JSON.parse(localStorage.getItem('vp_faculty')); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const oauthToken = params.get('token');
    if (oauthToken) {
      localStorage.setItem('vp_token', oauthToken);
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    const token = localStorage.getItem('vp_token');
    if (token) {
      api.get('/auth/me')
        .then(res => { setFaculty(res.data.faculty); })
        .catch(() => { localStorage.removeItem('vp_token'); localStorage.removeItem('vp_faculty'); setFaculty(null); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    localStorage.setItem('vp_token', res.data.token);
    localStorage.setItem('vp_faculty', JSON.stringify(res.data.faculty));
    setFaculty(res.data.faculty);
    return res.data;
  };

  const register = async (data) => {
    const res = await api.post('/auth/register', data);
    localStorage.setItem('vp_token', res.data.token);
    localStorage.setItem('vp_faculty', JSON.stringify(res.data.faculty));
    setFaculty(res.data.faculty);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('vp_token');
    localStorage.removeItem('vp_faculty');
    setFaculty(null);
  };

  const loginWithMicrosoft = () => {
    const isProd = process.env.NODE_ENV === 'production';
    const baseUrl = process.env.REACT_APP_SERVER_URL || (isProd ? '/api' : 'http://localhost:5000/api');
    window.location.href = `${baseUrl}/auth/microsoft`;
  };

  return (
    <AuthContext.Provider value={{ faculty, login, register, logout, loginWithMicrosoft, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
